import styled from '@emotion/styled';
import { useMediaQuery } from '@mui/material';
import Link from 'next/link';
import { YellowButton } from '@/components/button/button';
import { LoginSignupButton } from '@/components/login-signup-button/login-signup-button';
import { ExperienceFieldsFragment, ExperienceMode } from '@/generated/graphql';
import { useCurrentUser } from '@/hooks/use-current-user/use-current-user';
import { useScheduleWelcomeModalOpen } from '../hooks/use-schedule-welcome-modal-open/use-schedule-welcome-modal-open';
import { ScheduleWelcomeModal } from './schedule-welcome-modal';

const ButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  width: 100%;
  @media (max-width: 768px) {
    display: none;
  }
`;
const MobileButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
`;
type OneOnOneActionsProps = {
  experience: ExperienceFieldsFragment;
};

export const OneOnOneActions = ({ experience }: OneOnOneActionsProps) => {
  const { scheduleWelcomeModalOpen, setScheduleWelcomeModalOpen } = useScheduleWelcomeModalOpen();
  const isMobile = useMediaQuery('(max-width:768px)');
  const id = experience?.id;
  const { data: user } = useCurrentUser();

  const handleOpen = () => {
    if (scheduleWelcomeModalOpen === false) {
      setScheduleWelcomeModalOpen(true);
    }
  };

  if (!id) {
    return null;
  }
  const mode = experience?.mode;
  const welcome = !user?.welcomeVetted && mode === ExperienceMode.InPerson;
  const unavailable = !experience?.nextAvailability;
  let button: 'book' | 'welcome' | 'unavailable' = 'book';
  if (welcome) {
    button = 'welcome';
  } else if (unavailable) {
    button = 'unavailable';
  }

  const content = (
    <LoginSignupButton label="Sign up to book your One-on-One">
      {button === 'book' && (
        <Link href={`/experiences/${id}/book/`} passHref>
          <YellowButton>Book Experience</YellowButton>
        </Link>
      )}
      {button === 'welcome' && (
        <>
          <YellowButton onClick={handleOpen}>Schedule a Welcome</YellowButton>
          <ScheduleWelcomeModal />
        </>
      )}
      {button === 'unavailable' && <YellowButton disabled>Unavailable</YellowButton>}
    </LoginSignupButton>
  );
  if (isMobile) {
    return <MobileButtonRow>{content}</MobileButtonRow>;
  }
  return <ButtonRow>{content}</ButtonRow>;
};
